import React from "react";

const CustomButton = ({
  children,
  onClick,
  type = "button",
  disabled = false,
  className = "",
  variant = "primary", // primary, secondary, etc.
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`custom-button custom-button-${variant} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default CustomButton;

